// router/index.js
import { getUserRoles, isAuthenticated } from '@/utils/auth';
import { createRouter, createWebHistory } from 'vue-router'
import AppLayout from '@/layouts/AppLayout.vue'
import AuthLayout from '@/layouts/AuthLayout.vue'
import Login from '@/views/LoginPage.vue'
import Dashboard from '@/views/DashboardPage.vue'
import NotFound from '@/views/NotFoundPage.vue'
import ForbiddenPage from '@/views/ForbiddenPage.vue';
import WaterCollectionPage from '@/views/collections/WaterCollectionPage.vue';
import BusinessCollectionPage from '@/views/collections/BusinessCollectionPage.vue';
import CashTicketCollectionPage from '@/views/collections/CashTicketCollectionPage.vue';
import CTCCollectionPage from '@/views/collections/CTCCollectionPage.vue';
import GeneralCollectionPage from '@/views/collections/GeneralCollectionPage.vue';
import MarketStallCollectionPage from '@/views/collections/MarketStallCollectionPage.vue';
import LargeCattleTransferPage from '@/views/collections/LargeCattleTransferPage.vue';
import LargeCattleOwnershipPage from '@/views/collections/LargeCattleOwnershipPage.vue';
import RealPropertyCollectionPage from '@/views/collections/RealPropertyCollectionPage.vue';
import SlaughterPermitCollectionPage from '@/views/collections/SlaughterPermitCollectionPage.vue';
import AbstractRPTaxPage from '@/views/reports/abstract/AbstractRPTaxPage.vue';
import AbstractWaterPage from '@/views/reports/abstract/AbstractWaterPage.vue';
import AbstractGeneralPage from '@/views/reports/abstract/AbstractGeneralPage.vue';
import CollectionsReportPage from '@/views/reports/collections/CollectionsReportPage.vue';
import RDCDReportPage from '@/views/reports/collections/RDCDReportPage.vue';
import LiquidatingOfficerReportPage from '@/views/reports/collections/LiquidatingOfficerReportPage.vue';
import AccomplishmentReportPage from '@/views/reports/AccomplishmentReportPage.vue';
import CollectorCorrectionsReportPage from '@/views/reports/CollectorCorrectionsReportPage.vue';
import ConcessionaireSetupPage from '@/views/settings/ConcessionaireSetupPage.vue';
import AccountSetupPage from '@/views/settings/AccountSetupPage.vue';
import ChartOfAccountSetupPage from '@/views/settings/ChartOfAccountSetupPage.vue';
import UserSetupPage from '@/views/settings/UserSetupPage.vue';
import CashierRemittancePage from '@/views/logbooks/remittances/CashierRemittancePage.vue';
import CollectorRemittancePage from '@/views/logbooks/remittances/CollectorRemittancePage.vue';
import LogbookForm51Page from '@/views/logbooks/accountableforms/LogbookForm51Page.vue';
import LogbookForm52Page from '@/views/logbooks/accountableforms/LogbookForm52Page.vue';
import LogbookForm53Page from '@/views/logbooks/accountableforms/LogbookForm53Page.vue';
import LogbookForm54Page from '@/views/logbooks/accountableforms/LogbookForm54Page.vue';
import LogbookForm55Page from '@/views/logbooks/accountableforms/LogbookForm55Page.vue';
import LogbookForm56Page from '@/views/logbooks/accountableforms/LogbookForm56Page.vue';
import LogbookForm57Page from '@/views/logbooks/accountableforms/LogbookForm57Page.vue';
import LogbookForm58Page from '@/views/logbooks/accountableforms/LogbookForm58Page.vue';
import LogbookCashTicketPage from '@/views/logbooks/accountableforms/LogbookCashTicketPage.vue';
import LogbookCTCInvPage from '@/views/logbooks/accountableforms/LogbookCTCInvPage.vue';
import LogBookCTCCorpPage from '@/views/logbooks/accountableforms/LogBookCTCCorpPage.vue';
import LogbookLiquidatingOfficerPage from '@/views/logbooks/accountableforms/LogbookLiquidatingOfficerPage.vue';
import LogbookBankDepositGeneralPage from '@/views/logbooks/deposits/LogbookBankDepositGeneralPage.vue';
import LogbookBankDepositSEFPage from '@/views/logbooks/deposits/LogbookBankDepositSEFPage.vue';
import store from "@/store";
const routes = [
    {
        path: '/',
        component: AppLayout,
        meta: { requiresAuth: true }, // Requires authentication
        children: [
            {
                path: '',
                name: 'Dashboard',
                component: Dashboard,
                meta: {trackRecent: true,icon: 'bi bi-speedometer2'}
            },
            {
                path: '/collections/water',
                name: 'Water Collection',
                component: WaterCollectionPage,
                meta: { roles: ['admin', 'water-collection'],title: 'Treasury | Water' }
            },
            {
                path: '/collections/business',
                name: 'Business Collection',
                component: BusinessCollectionPage,
                meta: { roles: ['admin', 'business-collection'],title: 'Treasury | Business' }
            },
            {
                path: '/collections/cashticket',
                name: 'Cash Ticket',
                component: CashTicketCollectionPage,
                meta: { roles: ['admin', 'cashticket'],trackRecent: true, icon: 'bi bi-briefcase-fill', }
            },
            {
                path: '/collections/ctc',
                name: 'CTC',
                component: CTCCollectionPage,
                meta: { roles: ['admin', 'cashier','teller','collector'],title: 'Treasury | CTC',trackRecent: true, icon: 'bi bi-newspaper', }
            },
            {
                path: '/collections/general',
                name: 'General',
                component: GeneralCollectionPage,
                meta: { roles: ['admin', 'cashier','teller','collector'],title: 'Treasury | General', trackRecent: true,
                     icon: 'bi bi-collection', }
            },
            {
                path: '/collections/market',
                name: 'Market Stall Rental',
                component: MarketStallCollectionPage,
                meta: { roles: ['admin', 'market-rental'] }
            },
            {
                path: '/collections/lct',
                name: 'Large Cattle Transfer',
                component: LargeCattleTransferPage,
                meta: { roles: ['admin', 'lctransfer'] }
            },
            {
                path: '/collections/lco',
                name: 'Large Cattle Ownership',
                component: LargeCattleOwnershipPage,
                meta: { roles: ['admin', 'lcownership'] }
            },
            {
                path: '/collections/mlf',
                name: 'Marriage License Fee',
                component: LargeCattleOwnershipPage,
                meta: { roles: ['admin', 'mlfee'] }
            },
            {
                path: '/collections/rptax',
                name: 'Real Property Tax',
                component: RealPropertyCollectionPage,
                meta: { roles: ['admin', 'rptax'] }
            },
            {
                path: '/collections/slaughter',
                name: 'Slaughter Permit',
                component: SlaughterPermitCollectionPage,
                meta: { roles: ['admin', 'slaughter'] }
            },
            {
                path: '/reports/abstract/rptax',
                name: 'Abstract Report RPTax',
                component: AbstractRPTaxPage,
                meta: { roles: ['admin', 'abstract-rptax'] }
            },
            {
                path: '/reports/abstract/water',
                name: 'Abstract Report Water',
                component: AbstractWaterPage,
                meta: { roles: ['admin', 'abstract-water'] }
            },
            {
                path: '/reports/abstract/general',
                name: 'Abstract Report General',
                component: AbstractGeneralPage,
                meta: { roles: ['admin', 'abstract-general'] }
            },
            {
                path: '/reports/collections/cr',
                name: 'Collections Report Page',
                component: CollectionsReportPage,
                meta: { roles: ['admin', 'collections-report'] }
            },
            {
                path: '/reports/collections/rdcd',
                name: 'RDCD Reports',
                component: RDCDReportPage,
                meta: { roles: ['admin', 'collections-rdcd'] }
            },
            {
                path: '/reports/collections/lo',
                name: 'Liquidating Officer Reports',
                component: LiquidatingOfficerReportPage,
                meta: { roles: ['admin', 'collections-lo'] }
            },
            {
                path: '/reports/accomplishment',
                name: 'Accomplishment Reports',
                component: AccomplishmentReportPage,
                meta: { roles: ['admin', 'accomplishments-report'] }
            },
            {
                path: '/reports/corrections',
                name: 'Collector Corrections Reports',
                component: CollectorCorrectionsReportPage,
                meta: { roles: ['admin', 'corrections-report'] }
            },
            {
                path: '/settings/concessionaire',
                name: 'Concessionaire Setup Page',
                component: ConcessionaireSetupPage,
                meta: { roles: ['admin', 'concessionaire-setup'] }
            },
            {
                path: '/settings/account',
                name: 'Account Setup Page',
                component: AccountSetupPage,
                meta: { roles: ['admin', 'account-setup'] }
            },
            {
                path: '/settings/coa',
                name: 'Chart Of Accounts Setup Page',
                component: ChartOfAccountSetupPage,
                meta: { roles: ['admin', 'coa-setup'] }
            },
            {
                path: '/settings/user',
                name: 'User Setup Page',
                component: UserSetupPage,
                meta: { roles: ['admin', 'user-setup'] }
            },
            {
                path: '/logbook/accountable-forms/51',
                name: 'Accountable Form 51',
                component: LogbookForm51Page,
                meta: { roles: ['admin', 'liquidating-officer'] }
            },
            {
                path: '/logbook/accountable-forms/52',
                name: 'Accountable Form 52',
                component: LogbookForm52Page,
                meta: { roles: ['admin', 'liquidating-officer'] }
            },
            {
                path: '/logbook/accountable-forms/53',
                name: 'Accountable Form 53',
                component: LogbookForm53Page,
                meta: { roles: ['admin', 'liquidating-officer'] }
            },
            {
                path: '/logbook/accountable-forms/54',
                name: 'Accountable Form 54',
                component: LogbookForm54Page,
                meta: { roles: ['admin', 'liquidating-officer'] }
            },
            {
                path: '/logbook/accountable-forms/55',
                name: 'Accountable Form 55',
                component: LogbookForm55Page,
                meta: { roles: ['admin', 'liquidating-officer'] }
            },
            {
                path: '/logbook/accountable-forms/56',
                name: 'Accountable Form 56',
                component: LogbookForm56Page,
                meta: { roles: ['admin', 'liquidating-officer'] }
            },
            {
                path: '/logbook/accountable-forms/57',
                name: 'Accountable Form 57',
                component: LogbookForm57Page,
                meta: { roles: ['admin', 'liquidating-officer'] }
            },
            {
                path: '/logbook/accountable-forms/58',
                name: 'Accountable Form 58',
                component: LogbookForm58Page,
                meta: { roles: ['admin', 'liquidating-officer'] }
            },
            {
                path: '/logbook/accountable-forms/cashticket',
                name: 'Cash Ticket Logbook',
                component: LogbookCashTicketPage,
                meta: { roles: ['admin', 'liquidating-officer'] }
            },
            {
                path: '/logbook/accountable-forms/ctc-indv',
                name: 'CTC Individual',
                component: LogbookCTCInvPage,
                meta: { roles: ['admin', 'liquidating-officer'] }
            },
            {
                path: '/logbook/accountable-forms/ctc-corp',
                name: 'CTC Corporation',
                component: LogBookCTCCorpPage,
                meta: { roles: ['admin', 'liquidating-officer'] }
            },
            {
                path: '/logbook/bank-deposits/general',
                name: 'Bank Deposits General',
                component: LogbookBankDepositGeneralPage,
                meta: { roles: ['admin', 'liquidating-officer'] }
            },
             {
                path: '/logbook/bank-deposits/sef',
                name: 'Bank Deposits SEF',
                component: LogbookBankDepositSEFPage,
                meta: { roles: ['admin', 'liquidating-officer'] }
            },
            {
                path: '/logbook/remittances/cashier',
                name: 'Cashier Remittance',
                component: CashierRemittancePage,
                meta: { roles: ['admin', 'liquidating-officer'] }
            },
            {
                path: '/logbook/remittances/collector',
                name: 'Collector Remittance',
                component: CollectorRemittancePage,
                meta: { roles: ['admin', 'liquidating-officer','collector'] }
            },
            {
                path: '/logbook/liquidating-officer',
                name: 'Liquidating Officer',
                component: LogbookLiquidatingOfficerPage,
                meta: { roles: ['admin', 'liquidating-officer'] }
            },
        ]
    },
    {
        path: '/login',
        component: AuthLayout,
        meta: { requiresGuest: true,title: 'Treasury | Login' }, // Only accessible when not authenticated
        children: [
            {
                path: '',
                name: 'login',
                component: Login
            }
        ]
    },
    {
        path: '/forbidden',
        name: 'forbidden',
        component: ForbiddenPage,
    },
    {
        path: '/:pathMatch(.*)*', // Catch-all route for 404
        name: 'not-found',
        component: NotFound
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

// Authentication guard
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'Treasury'; // Fallback if no title
    const isAuthed = isAuthenticated(); // Implement your authentication check
    // Redirect to login if route requires auth and user is not authenticated
    if (to.meta.requiresAuth && !isAuthed) {
        return next({ name: 'login', query: { redirect: to.fullPath } })
    }

    // Redirect away from auth pages if already logged in
    if (to.meta.requiresGuest && isAuthed) {
        return next({ name: 'dashboard' })
    }

    // Handle role-based access control
    if (to.meta.roles && to.meta.roles.length > 0) {
        const userRoles = getUserRoles(); // Example function to get user roles
        const allowedRoles = to.meta.roles;

        // Check if any of the user's roles match the allowed roles
        const hasAccess = userRoles.some(role => allowedRoles.includes(role));

        if (!hasAccess) {
            // Redirect to unauthorized page or handle unauthorized access
            return next('/forbidden'); // Example redirect to unauthorized page
        }
    }

    next()
})
router.afterEach((to) => {
  if (to.meta?.trackRecent) {
    const pageToTrack = {
      path: to.path,
      name: to.name || to.path,
      icon: to.meta?.icon || 'default'
    }
    store.dispatch('trackPageVisit', pageToTrack);
  }
});

export default router